/* Copyright (c) Trimble Inc. All rights reserved. */
import React from "react";
import { Box } from "@material-ui/core";
import { useLocation, useParams } from "react-router";
import { useProductDetailsController } from "../components/product-details/ProductDetails.controller";
import { ProductDetailsViewer } from "../components/product-details/ProductDetails.viewer";
import { SubscriberPage } from "pages/home/subscriptions/pages/SubscriptionPage";
import { Breadcrumbs } from "modus/components/generic-page-title/Breadcrumbs";

export const ProductSummary: React.FC = () => {
  const { response, subscribe } = useProductDetailsController();
  const location = useLocation();
  const { productId } = useParams<any>();
  return (
    <Box m={2}>
      <Breadcrumbs
        links={[{ text: "Products", href: "/home/consumer/products" }]}
        pageTitle={response?.value?.data?.name}
      />
      {location.pathname ===
      `/home/consumer/products/${productId}/subscribe` ? (
        <SubscriberPage response={response} loadProduct={subscribe} />
      ) : (
        <ProductDetailsViewer response={response} subscribe={subscribe} />
      )}
    </Box>
  );
};

export default ProductSummary;
